<template>
  <div class="price_index js_price_index">
    <Introduce :moduleId="7"/>
    <p class="title">多种解决方案，满足企业不同需求</p>
    <div class="price_box">
      <ul class="mob_title" :class="{ four_title: list.length === 4 }">
        <li
          v-for="(item, index) in list"
          :key="item.pricingId"
          :class="{ active: mobIndex === index }"
          @click="mobIndexClick(index)"
        >
          {{ item.releaseName }}
        </li>
      </ul>
      <ul
        class="price-group"
        :class="{ price_one: list.length === 1 }"
        v-if="list.length > 0"
      >
        <li
          v-for="(item, index) in list"
          :key="item.pricingId"
          v-show="mobIndex === index"
          class="price-item"
        >
          <div class="item-header">
            <p class="name">{{ item.releaseName }}</p>
            <p class="desc">{{ item.releaseProfile }}</p>
          </div>
          <div class="item-main">
            <div class="price-box">
              <p
                class="price-cell"
                v-if="item.pricingList && item.pricingList.length === 1"
              >
                <span><label>￥</label>{{ item.pricingList[0].price }}</span>
                <span>{{ item.pricingList[0].unit }}</span>
              </p>
              <template v-else>
                <p
                  class="price-cell price-cell-item"
                  v-for="(p, i) in item.pricingList"
                  :key="i"
                >
                  <span><label>￥</label>{{ p.price }}</span>
                  <span>{{ p.unit }}</span>
                </p>
              </template>
            </div>
            <div class="con_list">
              <!-- <p class="con_include" v-if="item.containRelease">
                包含<span :class="`con_include_bc${index + 1}`">{{
                  item.containRelease
                }}</span
                >功能，以及
              </p> -->
              <p
                class="con_list_one"
                v-for="(funItem, funIndex) in item.functionName"
                :key="funIndex"
              >
                <i class="font_family icon-price_icon"></i>
                <span>{{ funItem }}</span>
              </p>
            </div>
          </div>
          <div class="item-footer">
            <a
              v-if="
                item.firmFreeUse &&
                  Object.is(item.firmFreeUse.buttonStatus, 'y')
              "
              :href="item.firmFreeUse.link"
              target="_blank"
              class="btn"
              @click.stop="handleBtnClick(item.firmFreeUse.name)"
            >
              {{ item.firmFreeUse.name }}
            </a>
          </div>
        </li>
      </ul>
      <Nothing class="nothing" v-else />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {getProductPricing} from "@/api/common/index.js";
import metaInfoMixins from "@/utils/mixin/metaInfoMixins";

export default {
  name: "index",
  mixins: [metaInfoMixins],
  data() {
    return {
      mobIndex: 0,
      list: []
    };
  },
  created() {
    if (this.$route.query.id) {
      this.mobIndex = parseInt(this.$route.query.id);
    }
    this.getProductPricingFun();
  },
  watch: {
    '$route'() {
      if (this.$route.query.id) {
        this.mobIndex = parseInt(this.$route.query.id);
      }
    }
  },
  mounted() {
    const el = $(".js_price_index");
    this.onResize(el);
  },
  methods: {
    getProductPricingFun() {
      getProductPricing().then((res) => {
        if (res.success) {
          this.list = res.data.contentList;
          this.$nextTick(() => {
            // 动态设置中间的高度
            const el = $(".js_price_index");
            this.setArrWidt(el);
          });
        }
      });
    },
    /**
     * 按钮点击事件
     */
    handleBtnClick(name) {
      const params = {
        officialSite_e_name: name,
        officialSite_e_freeUseDetailsSource: 'price',
        officialSite_e_productName: this.$store.getters.getProductBasicInfo.productName,
      }
      this.$sensors.officialSite_FreeUseDetails(params)
    },
    onResize(el) {
      window.onresize = () => {
        this.setArrWidt(el);
      };
    },
    setArrWidt(el) {
      let w = $(window).width();
      if (w > 720) {
        el.find(".con_priarr").css("height", "auto");
        let maxWidth = 0;
        el.find(".con_priarr").each((e, dom) => {
          let wid = $(dom).outerHeight();
          if (wid > maxWidth) {
            maxWidth = wid;
          }
        });
        el.find(".con_priarr").css("height", maxWidth + "px");
        let maxWidth2 = 0;
        el.find(".js_con_desc").each((e, dom) => {
          let wid = $(dom).outerHeight();
          if (wid > maxWidth2) {
            maxWidth2 = wid;
          }
        });
        el.find(".js_con_desc").css("height", maxWidth2 + "px");
      } else {
        el.find(".con_priarr").css("height", "100%");
        el.find(".js_con_desc").css("height", "auto");
      }
    },
    mobIndexClick(i) {
      this.mobIndex = i;
    }
  }
};
</script>

<style scoped lang="scss">
.price_index {
  .title {
    font-size: 32px;
    color: #333333;
    line-height: 45px;
    padding: 60px 0;
    text-align: center;
  }
  .price_box {
    padding: 0 60px;
    .mob_title {
      display: flex;
      li {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 66px;
        background: #FFFFFF;
        font-size: 28px;
        color: #333333;
        margin-left: 24px;
        &:first-child {
          margin-left: 0;
        }
      }
      .active {
        background: #0064EB;
        color: #FFFFFF;
      }
    }
    .four_title{
      flex-wrap: wrap;
      li{
        flex: none;
        width: 300px;
        margin-left: 24px;
        &:nth-child(2n+1){
          margin-left: 0;
        }
        &:nth-child(3){
          margin-top: 24px;
        }
        &:nth-child(4){
          margin-top: 24px;
        }
      }
    }
    .price-group {
      display: flex;
      justify-content: flex-start;
      overflow-x: auto;
      margin-top: 49px;
      padding-bottom: 60px;
      .price-item {
        width: 450px;
        color: #403c44;
        margin-left: 60px;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background-image: url('../../assets/images/price-bg-hover.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-clip: padding-box;
        overflow: hidden;
        border-radius: 12px;
        padding: 32px;
        transition: 0.8s;
        &:hover {
          background-image: url('../../assets/images/price-bg-hover.png');
        }
        .item-header {
          display: flex;
          align-items: center;
          justify-content: center;
          // height: 122px;
          flex-grow: 0;
          flex-shrink: 0;
          flex-flow: column;
          .name {
            font-size: 36px;
            font-weight: bold;
          }
          .desc {
            font-size: 28px;
            color: #909090;
            margin-top: 12px;
          }
        }
        .item-main {
          padding: 20px 0 40px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .price-cell {
            display: flex;
            align-items: flex-end;
            justify-content: center;
            margin: 0;
            span {
              &:first-child {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 54px;
                font-weight: bold;
                line-height: 1;
                text-align: right;
                label {
                  font-size: 40px;
                }
              }
              &:last-child {
                font-size: 30px;
                font-weight: 400;
                color: #333333;
                margin-left: 32px;
                text-align: left;
              }
            }
          }
          .price-cell-item {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            margin-top: 16px;
            &:first-child {
              margin-top: 0;
            }
            span {
              &:first-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 36px;
                width: 60%;
                text-align: right;
                font-weight: bold;
                line-height: 1;
                label {
                  font-size: 30px;
                }
              }
              &:last-child {
                width: 40%;
                font-size: 24px;
                color: #333333;
                text-align: left;
                margin-left: 32px;
              }
            }
          }
          .con_list {
            margin-top: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .con_include {
              font-size: 24px;
              color: #333333;
              line-height: 33px;
              display: flex;
              align-items: center;
              span {
                display: inline-block;
                padding: 2px 12px;
                border-radius: 6px;
                font-size: 26px;
                font-weight: 600;
                color: #ffffff;
                margin: 0 8px;
              }
              .con_include_bc1 {
                background: linear-gradient(108deg, #bdc9dc 0%, #8899b7 100%);
              }
              .con_include_bc2 {
                background: linear-gradient(90deg, #4e95f3 0%, #0056cb 100%);
              }
              .con_include_bc3 {
                background: linear-gradient(114deg, #405fb2 1%, #001f6e 100%);
              }
              .con_include_bc4 {
                background: linear-gradient(114deg, #605e69 0%, #252931 100%);
              }
            }
            .con_list_one {
              margin-top: 22px;
              width: 330px;
              display: flex;
              align-items: center;
              &:first-child {
                margin-top: 0;
              }
              i {
                font-size: 24px;
                color: #0064eb;
              }
              span {
                margin-left: 15px;
                font-size: 24px;
                color: #333333;
                line-height: 33px;
              }
            }
          }
        }
        .item-footer {
          width: 100%;
          a.btn {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 14px;
            width: 100%;
            height: 73px;
            font-size: 28px;
            background-color: #1174fa;
            color: #fff;
          }
        }
      }
    }
    .nothing{
      padding-bottom: 60px;
    }
  }
}
@media (min-width: 751px) and (max-width: 960px) {
  .price_index {
    .title {
      font-size: 32px;
      line-height: 45px;
      padding: 60px 0 40px 0;
      font-weight: bold;
    }
    .price_box {
      width:100%;
      margin: 0 auto;
      padding: 0;
      .mob_title {
        display: none;
      }
      .price-group {
        display: flex;
        justify-content: flex-start;
        overflow-x: auto;
        margin-top: 60px;
        padding-bottom: 60px;
        .price-item {
          width: 408px;
          margin-left: 24px;
          flex-grow: 0;
          flex-shrink: 0;
          display: flex !important;
          flex-direction: column;
          justify-content: space-between;
          &:first-child {
            margin-left: 60px;
          }
          &:last-child {
            margin-right: 60px;
          }
          .item-header {
          }
          .item-main {
            height: 100%;
            display: flex;
            flex-direction: column;
            .price-cell {
              margin: 0;
              span {
                &:first-child {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 48px;
                  font-weight: bold;
                  label {
                    font-size: 40px;
                  }
                }
                &:last-child {
                  font-size: 26px;
                  font-weight: 400;
                  color: #333333;
                  margin-left: 16px;
                }
              }
            }
            .price-cell-item {
              margin-top: 20px;
              &:first-child {
                margin-top: 0;
              }
              span {
                &:first-child {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  font-size: 30px;
                  text-align: right;
                  font-weight: bold;
                  label {
                    font-size: 26px;
                  }
                }
                &:last-child {
                  font-size: 20px;
                  color: #333333;
                  text-align: left;
                  margin-left: 32px;
                }
              }
            }
            .con_list {
              margin-top: 30px;
              .con_include {
                font-size: 26px;
                color: #333333;
                line-height: 37px;
                font-weight: 400;
                display: flex;
                align-items: center;
                span {
                  display: inline-block;
                  padding: 2px 12px;
                  background: linear-gradient(108deg, #bdc9dc 0%, #8899b7 100%);
                  border-radius: 6px;
                  font-size: 26px;
                  font-weight: 600;
                  color: #ffffff;
                  margin: 0 8px;
                }
              }
              .con_list_one {
                margin-top: 24px;
                width: 280px;
                &:first-child {
                  margin-top: 0;
                }
                i {
                  font-size: 24px;
                  color: #0064eb;
                }
                span {
                  margin-left: 15px;
                  font-size: 24px;
                  line-height: 33px;
                }
              }
            }
          }
          .item-footer {
            a.btn {
              height: 52px;
              font-size: 20px;
            }
          }
        }
      }
      .price_one{
        justify-content: center;
      }
    }
  }
}
@media (min-width: 961px) {
  .price_index {
    .title {
      font-size: 32px;
      line-height: 45px;
      padding: 60px 0 40px 0;
      font-weight: bold;
    }
    .price_box {
      width: 1200px;
      margin: 0 auto;
      padding: 0;
      .mob_title {
        display: none;
      }
      .price-group {
        width: 1200px;
        display: flex;
        justify-content: center;
        overflow-x: hidden;
        margin-top: 40px;
        padding-bottom: 60px;
        .price-item {
          width: auto;
          max-width: 27%;
          flex: 1;
          margin-left: 24px;
          flex-grow: 1;
          flex-shrink: 1;
          display: flex !important;
          flex-direction: column;
          justify-content: space-between;
          background-image: url('../../assets/images/price-bg.png');
          &:hover {
            box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.07);
          }
          &:first-child {
            margin-left: 0;
          }
          .item-header {
            .desc {
              font-size: 16px;
              margin-top: 8px;
            }
          }
          .item-main {
            box-sizing: border-box;
            height: 100%;
            .price-cell {
              margin: 0;
              span {
                &:first-child {
                  font-size: 44px;
                  font-weight: bold;
                  label {
                    font-size: 30px;
                  }
                }
                &:last-child {
                  font-size: 16px;
                  font-weight: 400;
                  color: #333333;
                  margin-left: 16px;
                }
              }
            }
            .price-cell-item {
              margin-top: 16px;
              &:first-child {
                margin-top: 0;
              }
              span {
                &:first-child {
                  text-align: right;
                  font-size: 26px;
                  label {
                    font-size: 22px;
                  }
                }
                &:last-child {
                  text-align: left;
                  font-size: 16px;
                  color: #333333;
                  margin-left: 16px;
                }
              }
            }
            .con_list {
              margin-top: 30px;
              .con_include {
                font-size: 18px;
                color: #333333;
                line-height: 25px;
                font-weight: 400;
                display: flex;
                align-items: center;
                span {
                  display: inline-block;
                  padding: 2px 12px;
                  background: linear-gradient(108deg, #bdc9dc 0%, #8899b7 100%);
                  border-radius: 3px;
                  font-size: 18px;
                  font-weight: 600;
                  color: #ffffff;
                  margin: 0 6px;
                }
              }
              .con_list_one {
                margin-top: 13px;
                width: 214px;
                &:first-child {
                  margin-top: 0;
                }
                i {
                  font-size: 16px;
                  color: #0064eb;
                }
                span {
                  margin-left: 9px;
                  font-size: 16px;
                  line-height: 25px;
                }
              }
            }
          }
          .item-footer {
            a.btn {
              height: 50px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
